KMVP.quoteQuickAssignment = {
    isFormBlocked: function () {
        return $('.js-quick-assignment').hasClass('form-blocked');
    },
    bindFormButton: function () {
        $(document).on('click', '.js-apply-quick-assignment-button', function() {
            KMVP.quoteQuickAssignment.onClickedSaveButton();
            var newCustomerPO = $('.js-po-number').val();
            var mustShipDate = $("[name='requestedDate']").val();

            if (KMVP.quoteQuickAssignment.isFormBlocked() || !(newCustomerPO || mustShipDate)) {
                return;
            }

            KMVP.quoteQuickAssignment.blockForm();

            $.ajax({
                url: $(this).data('quoteQuickAssignmentUrl'),
                type: "POST",
                data: {
                    newCustomerPO: newCustomerPO,
                    mustShipDate: mustShipDate
                },
                success: function (data) {
                    KMVP.quoteQuickAssignment.resetInputs();
                    KMVP.quoteQuickAssignment.applyData(data);
                },
                complete: function() {
                    KMVP.quoteQuickAssignment.unblockForm();
                }
            });
        });
    },
    applyData: function (data) {
        var newCustomerPO = data.newCustomerPO;
        if (newCustomerPO) {
            var newCustomerPOElement = $('.js-quote-po-number.js-animatable');
            newCustomerPOElement.html(newCustomerPO);
            KMVP.quoteQuickAssignment.animateElement(newCustomerPOElement);
        }
        var mustShipDate = data.mustShipDate;
        if (mustShipDate) {
            var mustShipElement = $('.js-quote-operation-details-table .js-quote-must-ship-date-cell .js-animatable');
            mustShipElement.html(mustShipDate);
            KMVP.quoteQuickAssignment.animateElement(mustShipElement);
        }
    },
    blockForm: function () {
        $('.js-quick-assignment .js-apply-quick-assignment-button').showSpinner();
        $('.js-quick-assignment').addClass('form-blocked');
    },
    unblockForm: function () {
        $('.js-quick-assignment').removeClass('form-blocked');
        $('.js-quick-assignment .js-apply-quick-assignment-button').hideSpinner();
    },
    resetInputs: function () {
        $('.js-po-number').val("");
        $("[name='requestedDate']").val("");
        $('.js-quick-assignment .js-datepicker').val("").attr("placeholder", "Revise requested Date");
    },
    animateElement: function (element) {
        element.addClass('success-text-animation icon-check');
        setTimeout(function () {
            element.removeClass('success-text-animation icon-check');
        }, 4000);
    },


    // log rocket
    isChangeSaved: true,
    ALLOWED_TIMEOUT: 5000,
    bindLogRocketEvents: function() {
        $('.js-po-number').on('change', KMVP.quoteQuickAssignment.poNumberInputOnChange);
        $('.quote-quick-assignment-section .js-formated-datepicker').on('change', KMVP.quoteQuickAssignment.requestedDeliveryDateOnChange);
    },
    poNumberInputOnChange: function() {
        KMVP.quoteQuickAssignment.isChangeSaved = false;
        KMVP.quoteQuickAssignment.resetTimeout();
    },
    requestedDeliveryDateOnChange: function () {
        KMVP.quoteQuickAssignment.isChangeSaved = false;
        KMVP.quoteQuickAssignment.resetTimeout();
    },
    onClickedSaveButton: function() {
        if (!KMVP.quoteQuickAssignment.isChangeSaved) {
            KMVP.quoteQuickAssignment.isChangeSaved = true;
            KMVP.quoteQuickAssignment.clearTimeout();
            KMVP.quoteQuickAssignment.trackPositiveLogRocketEvent();
        }
    },
    resetTimeout: function() {
        KMVP.quoteQuickAssignment.clearTimeout();
        KMVP.quoteQuickAssignment.logRocketEventTimout = setTimeout(KMVP.quoteQuickAssignment.trackNegativeLogRocketEvent, KMVP.quoteQuickAssignment.ALLOWED_TIMEOUT, false);
    },
    clearTimeout: function(){
        if (KMVP.quoteQuickAssignment.logRocketEventTimout) {
            clearTimeout(KMVP.quoteQuickAssignment.logRocketEventTimout);
        }
    },
    trackPositiveLogRocketEvent: function() {
        // after changing data in the form user clicked save button
        KMVP.logRocketService.trackEvent('apply_to_all_clicked_d2');
    },
    trackNegativeLogRocketEvent: function() {
        // after changing data in the form user didn't clicked save button
        KMVP.logRocketService.trackEvent('no_apply_to_all_clicked_d2');
    }
};

$(document).ready(function () {
    KMVP.quoteQuickAssignment.bindFormButton();
    KMVP.quoteQuickAssignment.resetInputs();
    KMVP.quoteQuickAssignment.bindLogRocketEvents();
});
